var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "footer", class: { "footer--fixed": _vm.isSplash } },
    [
      _c(
        "a",
        { staticClass: "footer-logo-link", attrs: { target: "_blank" } },
        [
          !_vm.isSplash
            ? _c("img", {
                attrs: {
                  src: require("../assets/logo_new.png"),
                  alt: "Refinitiv Labs",
                },
              })
            : _vm._e(),
        ]
      ),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("nav", { staticClass: "footer-nav" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.refinitiv.com/en/policies/privacy-statement#cookies",
            target: "_blank",
            rel: "noopener",
          },
        },
        [
          _vm._v(" Cookies"),
          _c("span", { staticClass: "visible-not-mobile" }, [
            _vm._v(" Policy"),
          ]),
        ]
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.refinitiv.com/en/policies/privacy-statement",
            target: "_blank",
            rel: "noopener",
          },
        },
        [
          _vm._v(" Privacy"),
          _c("span", { staticClass: "visible-not-mobile" }, [
            _vm._v(" Statement"),
          ]),
        ]
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.refinitiv.com/en/policies/terms-of-use",
            target: "_blank",
            rel: "noopener",
          },
        },
        [
          _vm._v(" Terms"),
          _c("span", { staticClass: "visible-not-mobile" }, [
            _vm._v(" of Use"),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }